// ФАЙЛ: resolveEventZone.ts
// НАЗНАЧЕНИЕ: Извлекает зону компоновки (ZoneId) из payload overlay-события,
// если backend её передал. Используется EffectsLayer, чтобы решить — рендерить
// эффект через зонный слот (ZonedEffectPortal → ZoneLayoutManager) или как
// раньше напрямую (полноэкранные/наслаивающиеся эффекты без зонной модели).
//
// Backend кладёт zone в разных местах в зависимости от плагина (см.
// overlay.service.ts): poll/drawing — плоское payload.zone; soundboard —
// вложенное payload.overlayConfig.zone. Проверяем оба варианта.

import { isZoneId, type ZoneId } from '@shared/lib/zone-layout'

/** Возвращает валидный ZoneId из payload события, либо null, если его нет. */
export function resolveEventZone(payload: unknown): ZoneId | null {
  if (!payload || typeof payload !== 'object') return null
  const p = payload as Record<string, unknown>

  if (isZoneId(p.zone)) return p.zone

  const overlayConfig = p.overlayConfig
  if (overlayConfig && typeof overlayConfig === 'object') {
    const zone = (overlayConfig as Record<string, unknown>).zone
    if (isZoneId(zone)) return zone
  }

  return null
}
